import React, { Component } from "react";
import { Formik, validateYupSchema, yupToFormErrors } from "formik";
import _, { result } from "lodash";
import Dialog from "@material-ui/core/es/Dialog/Dialog";
import LeftEducation from "./LeftEducation/LeftEducation";
import ModalHowToUse from '../../../modules/documents/modals/HowToUse/HowToUse';
import classes from "./SteperForm.module.scss";
import { connect } from "react-redux";
import { goToPage, goToPrevPage } from "../../../store/actions/page";
import Typography from "../../../modules/generic/components/Texts/Typography";
import Scrollbar from '../../../components/generic/Scrollbar/Scrollbar';

class Wizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      values: props.initialValues || {},
    };
  }

  static Page = ({ children, values, errors, setFieldValue }) => {
    return (
      <div className="kashif">
        {React.cloneElement(children, { values, errors, setFieldValue })}
      </div>
    );
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.forceNextStep) {
      this.setState({
        page: nextProps.forceNextStep.step,
        values: nextProps.forceNextStep.values,
      });
    }
  }

  next = (values) => {
    if (this.props.formType === "uploadToEdit") {
      this.setState((state) => ({
        page: Math.min(state.page, this.props.children.length - 1),
        values,
      }));
    } else {
      this.setState((state) => ({
        page: Math.min(state.page + 1, this.props.children.length - 1),
        values,
      }));
    }
  };

  handleSpecialClick = async (values, validateForm) => {
    const errorForm = await validateForm();
    //console.log(errorForm);
    if (errorForm && Object.keys(errorForm).length > 0) {
      const errorRef = document.querySelector('[hasError="true"]');
      if (errorRef) {
        if (errorRef.tagName === "A") {
          document
            .querySelector(".kashif")
            .parentElement.parentElement.scrollTo(
              0,
              document.querySelector('[hasError="true"]').offsetTop
            );
        } else if (errorRef.tagName === "SPAN") {
          document
            .querySelector('[hasError="true"]')
            .querySelector("input")?document
            .querySelector('[hasError="true"]')
            .querySelector("input")
            .focus():document
            .querySelector('[hasError="true"]')
            .querySelector("p").focus()
        } else if (errorRef.type === "checkbox") {
          document
            .querySelector(".kashif")
            .parentElement.parentElement.scrollTo(
              0,
              document.querySelector('[hasError="true"]').parentElement
                .parentElement.parentElement.offsetTop
            );
        } else {
          errorRef.focus();
        }
      }
      return false;
    }
    if (this.props.nextButton.onClick) {
      const { hasNextPage = true } = this.props.nextButton;
      if (hasNextPage) {
        this.next(values);
        this.props.nextButton
          .onClick(values, this.props.forceNextStep)
          .then(() => {
            this.next(values);
          });
      } else {
        this.props.nextButton.onClick(values);
      }
    } else {
      this.next(values);
    }
  };

  handleSpecialBackClick = (values) => {
    if (this.props.backButton.onClick) {
      this.props.backButton.onClick(values);
    }
  };

  isDisabled(errors, dirty, values) {
    if (this.props.formType === "uploadToEdit") {
      if (this.state.page === 0) {
        return !values.file;
      } else if (this.state.page === 1) {
        return (
          !values.file ||
          values.confirmSameData !== true ||
          !values.confirmSameData ||
          !(Object.keys(errors).length === 0)
        );
      } else {
        if (values) {
          return !values.file || values.file === null;
        }
      }
    } else {
      return !(Object.keys(errors).length === 0);
    }
  }

  previous = () => {
    this.setState((state) => ({
      page: Math.max(state.page - 1, 0),
    }));
    // this.props.goToPrevStep();
  };

  validate = (values) => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ];
    return activePage.props.validate ? activePage.props.validate(values) : {};
  };

  handleRef = (element) => {
    if (this.props.handleRef) {
      this.props.handleRef(element);
    }
  };

  updateScreen = screen => {
    this.setState(() => {
      return { screen }
    })
  };

  handleSubmit = (values, bag) => {
    const { children, onSubmit } = this.props;
    const { page } = this.state;
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      return onSubmit(values);
    } else {
      this.next(values);
      bag.setSubmitting(false);
    }
  };

  goBack = (goBackInfo) => {
    this.props.goToPrevPage();
  };

  render() {
    const { children, hideClose, validationSchema } = this.props;
    const { page, values } = this.state;
    const pages = React.Children.toArray(children);
    const isLastPage = page === React.Children.count(children) - 1;

    const handleShowHowToUse = () => {
      let result = true
      if (!_.isEmpty(values)) {
        result = false;
      }
      return result;
    };

    // const formRightClassModified =
    //   this.props.formType === "uploadToEdit"
    //     ? classes.formRightClassModified
    //     : classes.genericFormRight;
    // const formRightClassByCondition =
    //   this.state.page === 2
    //     ? classes.formRightClassOnStep3
    //     : formRightClassModified;
    // const formLeftClassByCondition =
    //   this.state.page === 2 ? classes.genericFormLeftModified : null;
    if (this.props.fullScreenModal) {
      return (
        <div
          style={{
            zIndex: 99999,
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            backgroundColor: "white",
          }}
        >
          {this.props.fullScreenModal}
        </div>
      );
    } else {
      //console.log('Wizard.validationSchema: ', validationSchema);
      return (
        <>
          <Formik
            initialValues={values}
            enableReinitialize={false}
            validate={(value) => {
              try {
                validateYupSchema(value, validationSchema, true, value);
              } catch (err) {
                return yupToFormErrors(err); //for rendering validation errors
              }
              return {};
            }}
            onSubmit={this.handleSubmit}
            // validationSchema={validationSchema}
            isInitialValid={
              this.props.isInitialValid
                ? validationSchema.isValidSync(values)
                : false
            }
            initialErrors={false}
            innerRef={(element) => {
              this.handleRef(element);
            }}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              values,
              errors,
              dirty,
              handleSubmit,
              isSubmitting,
              handleReset,
              validateForm,
              setFieldValue,
              isValid,
            }) => {
              const activePage = React.cloneElement(pages[page], {
                values,
                errors,
                setFieldValue,
              });
              return (
                <form onSubmit={handleSubmit} className={"FormWizard"}>
                  <Dialog
                    fullScreen
                    disableEnforceFocus
                    disableEscapeKeyDown
                    open={true}
                    onClose={() => {
                      this.props.handleClose(true);
                    }}
                  >
                    <div className={classes.genericForm}>
                      <div className={classes.genericFormLeft}>
                        <div className={classes.titles}>
                          <LeftEducation
                            updateScreen={this.updateScreen}
                            showDisclaimer={
                              this.props.showDisclaimer ? true : false
                            }
                            leftEducationId={this.props.leftEducationId}
                          />
                        </div>
                      </div>
                      <Scrollbar className={classes.genericFormRight}>
                        <header>
                          <img src="/img/clara_logo.svg" alt="Clara" />
                        </header>
                        <div className={classes.StepFormZone}>
                          <Typography component="h1" className={classes.TitleScreen}>{this.state.screen}</Typography>
                          {activePage}
                          {this.props.showButtons !== false ? (
                            <div
                              className={`${classes.Botonera} ${page > 0
                                  ? classes.NotFirstPageButtons
                                  : classes.FirstPageButtons
                                }`
                              }
                            >
                              {page > 0 && (
                                <React.Fragment>
                                  {this.props.backButton ?
                                    this.props.backButton.button ? (
                                      <button
                                        disabled={this.isDisabled(
                                          errors,
                                          dirty,
                                          values
                                        )}
                                        type="submit"
                                        data-cy="submit"
                                        className={classes.Button}
                                        onClick={() =>
                                          this.handleSpecialBackClick(values)
                                        }
                                      >
                                        {this.props.backButton.button}
                                      </button>
                                    ) : (<div />)
                                    : (
                                      <button
                                        type="button"
                                        className={classes.previousButton}
                                        onClick={this.previous}
                                      >
                                        <svg
                                          width="38"
                                          height="38"
                                          viewBox="0 0 38 38"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z"
                                            fill="white"
                                            stroke="#EAF1FE"
                                          />
                                          <path
                                            d="M19.5 25.4971L14.5 20.4971L19.5 15.4971"
                                            stroke="#2C74FF"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M14.5 20.4971H25.5"
                                            stroke="#2C74FF"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </button>
                                    )}
                                </React.Fragment>
                              )}
                              {!isLastPage ? (
                                // Continue
                                <React.Fragment>
                                  {this.props.nextButton ? (
                                    <>
                                      {_.get(
                                        this.props,
                                        "extraButton.button",
                                        null
                                      )}
                                      <div>
                                        <button
                                          className={classes.Button}
                                          onClick={() => this.props.handleClose()}
                                        >
                                          <svg
                                            width="102"
                                            height="40"
                                            viewBox="0 0 102 40"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H98C99.933 0.5 101.5 2.067 101.5 4V36C101.5 37.933 99.933 39.5 98 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z"
                                              fill="white"
                                              stroke="#2C74FF"
                                            />
                                            <path
                                              d="M35.1599 24.104C34.2585 24.104 33.4785 23.9133 32.8199 23.532C32.1612 23.1507 31.6542 22.6047 31.2989 21.894C30.9522 21.1747 30.7789 20.3297 30.7789 19.359C30.7789 18.3883 30.9522 17.552 31.2989 16.85C31.6542 16.1393 32.1612 15.5933 32.8199 15.212C33.4785 14.8307 34.2585 14.64 35.1599 14.64C35.7839 14.64 36.3645 14.7353 36.9019 14.926C37.4479 15.1167 37.9115 15.3983 38.2929 15.771L37.8249 16.772C37.3915 16.4167 36.9625 16.161 36.5379 16.005C36.1219 15.8403 35.6669 15.758 35.1729 15.758C34.2195 15.758 33.4785 16.07 32.9499 16.694C32.4212 17.3093 32.1569 18.1977 32.1569 19.359C32.1569 20.5203 32.4169 21.4173 32.9369 22.05C33.4655 22.674 34.2109 22.986 35.1729 22.986C35.6669 22.986 36.1219 22.908 36.5379 22.752C36.9625 22.5873 37.3915 22.3273 37.8249 21.972L38.2929 22.973C37.9115 23.3457 37.4479 23.6273 36.9019 23.818C36.3645 24.0087 35.7839 24.104 35.1599 24.104ZM42.3856 24.091C41.805 24.091 41.2936 23.9567 40.8516 23.688C40.4183 23.4107 40.0803 23.0207 39.8376 22.518C39.6036 22.0067 39.4866 21.4087 39.4866 20.724C39.4866 20.0393 39.608 19.4413 39.8506 18.93C40.0933 18.41 40.4313 18.007 40.8646 17.721C41.3066 17.435 41.8136 17.292 42.3856 17.292C42.9663 17.292 43.4603 17.435 43.8676 17.721C44.2836 17.9983 44.5653 18.397 44.7126 18.917L44.5566 19.021V17.448H45.8566V24H44.5566V22.401L44.7126 22.466C44.5653 22.986 44.2836 23.389 43.8676 23.675C43.4603 23.9523 42.9663 24.091 42.3856 24.091ZM42.6976 23.051C43.287 23.051 43.742 22.8473 44.0626 22.44C44.392 22.0327 44.5566 21.452 44.5566 20.698C44.5566 19.944 44.392 19.3633 44.0626 18.956C43.742 18.5487 43.287 18.345 42.6976 18.345C42.0996 18.345 41.6316 18.5573 41.2936 18.982C40.9643 19.398 40.7996 19.9787 40.7996 20.724C40.7996 21.4693 40.9643 22.0457 41.2936 22.453C41.6316 22.8517 42.0996 23.051 42.6976 23.051ZM47.9025 24V19.294C47.9025 18.9907 47.8938 18.683 47.8765 18.371C47.8678 18.059 47.8418 17.7513 47.7985 17.448H49.0465L49.1635 18.774L49.0335 18.852C49.2242 18.3407 49.5275 17.955 49.9435 17.695C50.3682 17.4263 50.8535 17.292 51.3995 17.292C52.9682 17.292 53.7525 18.1717 53.7525 19.931V24H52.4395V19.983C52.4395 19.4197 52.3268 19.008 52.1015 18.748C51.8762 18.488 51.5295 18.358 51.0615 18.358C50.4982 18.358 50.0475 18.5313 49.7095 18.878C49.3802 19.2247 49.2155 19.6883 49.2155 20.269V24H47.9025ZM58.5856 24.091C57.9269 24.091 57.3549 23.9523 56.8696 23.675C56.3929 23.3977 56.0246 23.0077 55.7646 22.505C55.5046 22.0023 55.3746 21.4087 55.3746 20.724C55.3746 20.0393 55.5089 19.4413 55.7776 18.93C56.0462 18.41 56.4232 18.007 56.9086 17.721C57.4026 17.435 57.9832 17.292 58.6506 17.292C59.1012 17.292 59.5389 17.3657 59.9636 17.513C60.3882 17.6603 60.7349 17.8683 61.0036 18.137L60.6006 19.086C60.2972 18.8433 59.9896 18.6613 59.6776 18.54C59.3742 18.4187 59.0622 18.358 58.7416 18.358C58.1176 18.358 57.6236 18.5617 57.2596 18.969C56.9042 19.3763 56.7266 19.957 56.7266 20.711C56.7266 21.465 56.9042 22.0413 57.2596 22.44C57.6149 22.8387 58.1089 23.038 58.7416 23.038C59.0536 23.038 59.3656 22.9773 59.6776 22.856C59.9896 22.7347 60.2972 22.5527 60.6006 22.31L61.0036 23.259C60.7262 23.519 60.3709 23.7227 59.9376 23.87C59.5042 24.0173 59.0536 24.091 58.5856 24.091ZM67.8419 23.246C67.5472 23.506 67.1745 23.714 66.7239 23.87C66.2732 24.0173 65.8139 24.091 65.3459 24.091C64.6525 24.091 64.0545 23.9567 63.5519 23.688C63.0492 23.4193 62.6635 23.0293 62.3949 22.518C62.1262 22.0067 61.9919 21.4 61.9919 20.698C61.9919 20.022 62.1219 19.4283 62.3819 18.917C62.6505 18.4057 63.0189 18.007 63.4869 17.721C63.9549 17.435 64.4965 17.292 65.1119 17.292C65.7012 17.292 66.2082 17.422 66.6329 17.682C67.0575 17.942 67.3825 18.3147 67.6079 18.8C67.8419 19.2767 67.9589 19.853 67.9589 20.529V20.75H63.1359L63.1489 19.97H67.1919L66.8149 20.438C66.8235 19.736 66.6849 19.1987 66.3989 18.826C66.1129 18.4533 65.6925 18.267 65.1379 18.267C64.5572 18.267 64.1022 18.475 63.7729 18.891C63.4435 19.2983 63.2789 19.8703 63.2789 20.607C63.2789 21.4303 63.4565 22.0457 63.8119 22.453C64.1672 22.8517 64.6872 23.051 65.3719 23.051C65.7445 23.051 66.1042 22.9903 66.4509 22.869C66.7975 22.7477 67.1269 22.5613 67.4389 22.31L67.8419 23.246ZM69.5825 24V14.432H70.8955V24H69.5825Z"
                                              fill="#2C74FF"
                                            />
                                          </svg>
                                        </button>
                                        <button
                                          // disabled={this.isDisabled(errors, dirty, values)}
                                          type="submit"
                                          data-cy="submit"
                                          className={classes.Button}
                                          // onClick={() => handleSubmit(values)}
                                          onClick={() =>
                                            this.handleSpecialClick(
                                              values,
                                              validateForm
                                            )
                                          }
                                        >
                                          {this.props.nextButton.button}
                                        </button>
                                      </div>
                                    </>
                                  ) : (
                                    <button
                                      // disabled={this.isDisabled(errors, dirty)}
                                      type="submit"
                                      className={classes.Button}
                                      onClick={this.next}
                                      data-cy="submit"
                                    >
                                      <svg
                                        width="118"
                                        height="40"
                                        viewBox="0 0 118 40"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H114C115.933 0.5 117.5 2.067 117.5 4V36C117.5 37.933 115.933 39.5 114 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z"
                                          fill="white"
                                          stroke="#2C74FF"
                                        />
                                        <path
                                          d="M35.4346 24.104C34.542 24.104 33.762 23.9133 33.0946 23.532C32.436 23.142 31.929 22.5917 31.5736 21.881C31.2183 21.1703 31.0406 20.3297 31.0406 19.359C31.0406 18.397 31.2183 17.5607 31.5736 16.85C31.929 16.1393 32.436 15.5933 33.0946 15.212C33.762 14.8307 34.542 14.64 35.4346 14.64C36.0673 14.64 36.6523 14.7397 37.1896 14.939C37.7356 15.1297 38.195 15.4113 38.5676 15.784L38.0996 16.772C37.6663 16.4167 37.2373 16.161 36.8126 16.005C36.3966 15.8403 35.9416 15.758 35.4476 15.758C34.4856 15.758 33.7403 16.07 33.2116 16.694C32.6916 17.318 32.4316 18.2063 32.4316 19.359C32.4316 20.5203 32.6916 21.4173 33.2116 22.05C33.7403 22.674 34.4856 22.986 35.4476 22.986C35.9416 22.986 36.3966 22.908 36.8126 22.752C37.2373 22.5873 37.6663 22.3273 38.0996 21.972L38.5676 22.96C38.195 23.3327 37.7356 23.6187 37.1896 23.818C36.6523 24.0087 36.0673 24.104 35.4346 24.104ZM42.9594 24.091C42.3181 24.091 41.7547 23.9523 41.2694 23.675C40.7841 23.3977 40.4071 23.0033 40.1384 22.492C39.8784 21.9807 39.7484 21.3827 39.7484 20.698C39.7484 20.0133 39.8784 19.4153 40.1384 18.904C40.4071 18.384 40.7841 17.9853 41.2694 17.708C41.7547 17.4307 42.3181 17.292 42.9594 17.292C43.5921 17.292 44.1511 17.4307 44.6364 17.708C45.1217 17.9853 45.4944 18.384 45.7544 18.904C46.0231 19.4153 46.1574 20.0133 46.1574 20.698C46.1574 21.3827 46.0231 21.9807 45.7544 22.492C45.4944 23.0033 45.1217 23.3977 44.6364 23.675C44.1511 23.9523 43.5921 24.091 42.9594 24.091ZM42.9464 23.051C43.5531 23.051 44.0167 22.8517 44.3374 22.453C44.6581 22.0543 44.8184 21.4693 44.8184 20.698C44.8184 19.944 44.6537 19.3633 44.3244 18.956C44.0037 18.5487 43.5487 18.345 42.9594 18.345C42.3614 18.345 41.8977 18.5487 41.5684 18.956C41.2391 19.3633 41.0744 19.944 41.0744 20.698C41.0744 21.4693 41.2347 22.0543 41.5554 22.453C41.8847 22.8517 42.3484 23.051 42.9464 23.051ZM51.3061 17.292C52.8748 17.292 53.6591 18.1673 53.6591 19.918V24H52.3461V19.996C52.3461 19.424 52.2335 19.008 52.0081 18.748C51.7915 18.488 51.4405 18.358 50.9551 18.358C50.4005 18.358 49.9541 18.5313 49.6161 18.878C49.2868 19.2247 49.1221 19.6883 49.1221 20.269V24H47.8221V19.294C47.8221 18.6093 47.7875 17.994 47.7181 17.448H48.9401L49.0571 18.579C49.2651 18.163 49.5641 17.8467 49.9541 17.63C50.3528 17.4047 50.8035 17.292 51.3061 17.292ZM57.3612 18.462V21.751C57.3612 22.2017 57.4565 22.5223 57.6472 22.713C57.8465 22.895 58.1195 22.986 58.4662 22.986C58.6915 22.986 58.9212 22.9513 59.1552 22.882V23.948C58.8692 24.0433 58.5442 24.091 58.1802 24.091C57.5042 24.091 56.9798 23.9003 56.6072 23.519C56.2345 23.1377 56.0482 22.583 56.0482 21.855V18.462H54.7742V17.448H56.0482V15.81L57.3612 15.355V17.448H59.1682V18.462H57.3612ZM60.5108 17.448H61.8108V24H60.5108V17.448ZM61.9148 14.588V15.966H60.3938V14.588H61.9148ZM67.3494 17.292C68.9181 17.292 69.7024 18.1673 69.7024 19.918V24H68.3894V19.996C68.3894 19.424 68.2768 19.008 68.0514 18.748C67.8348 18.488 67.4838 18.358 66.9984 18.358C66.4438 18.358 65.9974 18.5313 65.6594 18.878C65.3301 19.2247 65.1654 19.6883 65.1654 20.269V24H63.8654V19.294C63.8654 18.6093 63.8308 17.994 63.7614 17.448H64.9834L65.1004 18.579C65.3084 18.163 65.6074 17.8467 65.9974 17.63C66.3961 17.4047 66.8468 17.292 67.3494 17.292ZM77.3955 17.448V24H76.1215V22.908C75.9135 23.2893 75.6275 23.584 75.2635 23.792C74.8995 23.9913 74.4878 24.091 74.0285 24.091C72.4512 24.091 71.6625 23.2157 71.6625 21.465V17.448H72.9625V21.452C72.9625 21.9893 73.0708 22.388 73.2875 22.648C73.5128 22.8993 73.8508 23.025 74.3015 23.025C74.8388 23.025 75.2678 22.8517 75.5885 22.505C75.9178 22.1583 76.0825 21.699 76.0825 21.127V17.448H77.3955ZM85.0387 20.75H80.3587C80.402 22.284 81.0997 23.051 82.4517 23.051C83.2057 23.051 83.8947 22.804 84.5187 22.31L84.9217 23.246C84.627 23.506 84.25 23.714 83.7907 23.87C83.34 24.0173 82.885 24.091 82.4257 24.091C81.377 24.091 80.5537 23.792 79.9557 23.194C79.3577 22.5873 79.0587 21.7597 79.0587 20.711C79.0587 20.0437 79.1887 19.45 79.4487 18.93C79.7173 18.41 80.09 18.007 80.5667 17.721C81.0433 17.435 81.585 17.292 82.1917 17.292C83.0757 17.292 83.769 17.578 84.2717 18.15C84.783 18.722 85.0387 19.515 85.0387 20.529V20.75ZM82.2177 18.267C81.7237 18.267 81.3207 18.4143 81.0087 18.709C80.6967 19.0037 80.4973 19.424 80.4107 19.97H83.8817C83.8297 19.4153 83.6607 18.995 83.3747 18.709C83.0887 18.4143 82.703 18.267 82.2177 18.267Z"
                                          fill="#192A3E"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                </React.Fragment>
                              ) : // Submit
                                this.props.showNextButton !== false ? (
                                  <button
                                    // disabled={!isValid  ||  this.isDisabled(errors, dirty)}
                                    type="submit"
                                    data-cy="submit"
                                    onClick={() => this.handleSubmit(values)}
                                    className={classes.Button}
                                  >
                                    <svg
                                      width="118"
                                      height="40"
                                      viewBox="0 0 118 40"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0 4C0 1.79086 1.79086 0 4 0H114C116.209 0 118 1.79086 118 4V36C118 38.2091 116.209 40 114 40H4C1.79086 40 0 38.2091 0 36V4Z"
                                        fill="#2C74FF"
                                      />
                                      <path
                                        d="M40.5915 24.104C39.8722 24.104 39.2135 24.0087 38.6155 23.818C38.0262 23.6273 37.5149 23.3413 37.0815 22.96L37.5625 21.972C38.0132 22.336 38.4812 22.6003 38.9665 22.765C39.4519 22.9297 39.9979 23.012 40.6045 23.012C41.2979 23.012 41.8352 22.882 42.2165 22.622C42.5979 22.362 42.7885 21.9937 42.7885 21.517C42.7885 21.1183 42.6109 20.8193 42.2555 20.62C41.9002 20.412 41.3369 20.2213 40.5655 20.048C39.8289 19.892 39.2265 19.7143 38.7585 19.515C38.2905 19.307 37.9222 19.034 37.6535 18.696C37.3849 18.3493 37.2505 17.9073 37.2505 17.37C37.2505 16.8327 37.3935 16.3603 37.6795 15.953C37.9655 15.537 38.3685 15.2163 38.8885 14.991C39.4172 14.757 40.0239 14.64 40.7085 14.64C41.3585 14.64 41.9652 14.7397 42.5285 14.939C43.1005 15.1383 43.5772 15.42 43.9585 15.784L43.4775 16.772C43.0529 16.4167 42.6152 16.1567 42.1645 15.992C41.7139 15.8187 41.2329 15.732 40.7215 15.732C40.0542 15.732 39.5299 15.875 39.1485 16.161C38.7672 16.4383 38.5765 16.8197 38.5765 17.305C38.5765 17.721 38.7412 18.0373 39.0705 18.254C39.4085 18.4707 39.9459 18.6657 40.6825 18.839C41.4539 19.0123 42.0779 19.1943 42.5545 19.385C43.0312 19.5757 43.4125 19.8357 43.6985 20.165C43.9845 20.4943 44.1275 20.919 44.1275 21.439C44.1275 21.9763 43.9845 22.4443 43.6985 22.843C43.4125 23.2417 43.0009 23.5537 42.4635 23.779C41.9349 23.9957 41.3109 24.104 40.5915 24.104ZM51.4961 17.448V24H50.2221V22.908C50.0141 23.2893 49.7281 23.584 49.3641 23.792C49.0001 23.9913 48.5884 24.091 48.1291 24.091C46.5518 24.091 45.7631 23.2157 45.7631 21.465V17.448H47.0631V21.452C47.0631 21.9893 47.1714 22.388 47.3881 22.648C47.6134 22.8993 47.9514 23.025 48.4021 23.025C48.9394 23.025 49.3684 22.8517 49.6891 22.505C50.0184 22.1583 50.1831 21.699 50.1831 21.127V17.448H51.4961ZM57.0203 17.292C57.5923 17.292 58.0993 17.4307 58.5413 17.708C58.9833 17.9853 59.3256 18.3797 59.5683 18.891C59.811 19.4023 59.9323 19.996 59.9323 20.672C59.9323 21.348 59.8066 21.946 59.5553 22.466C59.3126 22.9773 58.9703 23.376 58.5283 23.662C58.0863 23.948 57.5836 24.091 57.0203 24.091C56.5176 24.091 56.0756 23.987 55.6943 23.779C55.3216 23.5623 55.04 23.2547 54.8493 22.856V24H53.5493V14.432H54.8493V18.527C55.04 18.137 55.3216 17.8337 55.6943 17.617C56.0756 17.4003 56.5176 17.292 57.0203 17.292ZM56.7213 23.051C57.3106 23.051 57.77 22.843 58.0993 22.427C58.4286 22.0023 58.5933 21.4173 58.5933 20.672C58.5933 19.9353 58.4286 19.3633 58.0993 18.956C57.77 18.5487 57.3106 18.345 56.7213 18.345C56.1233 18.345 55.6596 18.5487 55.3303 18.956C55.0096 19.3633 54.8493 19.944 54.8493 20.698C54.8493 21.452 55.0096 22.0327 55.3303 22.44C55.6596 22.8473 56.1233 23.051 56.7213 23.051ZM69.0762 17.292C70.5322 17.292 71.2602 18.1673 71.2602 19.918V24H69.9472V19.983C69.9472 19.4197 69.8475 19.008 69.6482 18.748C69.4575 18.488 69.1455 18.358 68.7122 18.358C68.2095 18.358 67.8108 18.5313 67.5162 18.878C67.2302 19.2247 67.0872 19.697 67.0872 20.295V24H65.7742V19.983C65.7742 19.4197 65.6745 19.008 65.4752 18.748C65.2845 18.488 64.9725 18.358 64.5392 18.358C64.0365 18.358 63.6378 18.5313 63.3432 18.878C63.0485 19.2247 62.9012 19.697 62.9012 20.295V24H61.6012V19.294C61.6012 18.6093 61.5665 17.994 61.4972 17.448H62.7192L62.8362 18.54C63.0268 18.1413 63.2998 17.8337 63.6552 17.617C64.0105 17.4003 64.4265 17.292 64.9032 17.292C65.9172 17.292 66.5802 17.7123 66.8922 18.553C67.0915 18.163 67.3818 17.8553 67.7632 17.63C68.1532 17.4047 68.5908 17.292 69.0762 17.292ZM73.2712 17.448H74.5712V24H73.2712V17.448ZM74.6752 14.588V15.966H73.1542V14.588H74.6752ZM78.3288 18.462V21.751C78.3288 22.2017 78.4241 22.5223 78.6148 22.713C78.8141 22.895 79.0871 22.986 79.4338 22.986C79.6591 22.986 79.8888 22.9513 80.1228 22.882V23.948C79.8368 24.0433 79.5118 24.091 79.1478 24.091C78.4718 24.091 77.9475 23.9003 77.5748 23.519C77.2021 23.1377 77.0158 22.583 77.0158 21.855V18.462H75.7418V17.448H77.0158V15.81L78.3288 15.355V17.448H80.1358V18.462H78.3288Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </button>
                                ) : null}
                            </div>
                          ) : (
                            <div className={classes.Footer}>
                              {this.props.footer}
                            </div>
                          )}
                        </div>
                      </Scrollbar>
                    </div>
                    {/*
						DON'T DELETE THIS, COMMENT IT.
					*/}

                    {process.env.REACT_APP_DEBUG &&
                      <div style={{
                        position: 'fixed',
                        top: '0px',
                        left: '1300px',
                        zIndex: '999',
                        background: 'lightgray',
                        border: 'red',
                        borderLeft: 'solid',
                        overflow: 'scroll',
                        width: '410px',
                        height: '100vh'
                      }}
                      >

                        {/*!!!!!!!!!!!!!!DON'T DELETE THIS!!!!!!!!!!!!!!!!!!!!!!!! */}
                        {/*{*/}
                        {/*<pre>{this.props.formType}</pre>*/}
                        {/*<pre>{this.state.page}</pre>*/}
                        {<pre>{JSON.stringify(values, null, 2)}</pre>}
                        {/*}*/}
                        {/*{*/}
                        {<pre>{JSON.stringify(errors, null, 2)}</pre>}
                        {/*}*/}
                      </div>
                    }

                  </Dialog>
                </form>
              );
            }}
          </Formik>
          {handleShowHowToUse() && (
            <ModalHowToUse></ModalHowToUse>
          )}
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};
const mapDispatchToProps = (dispatch) => ({
  goToPage: (page, params) => {
    goToPage(dispatch, page, params);
  },
  goToPrevPage: (reload, defaultPage, params) => {
    goToPrevPage(dispatch, reload, defaultPage, params);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Wizard);
